<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapState("snackbar", [
      "color",
      "bottom",
      "top",
      "left",
      "right",
      "timeout",
      "message",
      "button",
      "buttonColor",
      "icon",
      "iconColor"
    ])
  },

  data() {
    return {
      visible: false
    };
  },

  methods: {
    ...mapActions("snackbar", ["setSnackbar"]),
    close() {
      this.setSnackbar(false);
    }
  },

  watch: {
    message(message) {
      this.visible = message;
    },
    visible(visible) {
      if (!visible) this.setSnackbar(false);
    }
  }
};
</script>

<template>
  <v-snackbar
    :bottom="bottom"
    :top="top"
    :left="left"
    :right="right"
    :color="color"
    v-model="visible"
    :timeout="timeout"
  >
    <v-layout row align-center>
      <v-icon v-if="icon" v-html="icon" :color="iconColor" class="mr-10" />
      <span v-if="message" v-html="message" />
    </v-layout>
    <v-btn
      v-if="button"
      :color="buttonColor"
      text
      @click="close()"
      v-html="button"
    />
  </v-snackbar>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Snackbar.vue